import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Sprite from '~components/Sprite'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/shift-toward.css'

class InfoBubble extends Component {
  constructor (props) {
    super()
    this.infoRef = React.createRef()
  }

  componentDidMount () {
    const { tooltip } = this.props

    if (tooltip) {
      tippy(this.infoRef.current, {
        content: tooltip,
        theme: 'pink',
        animation: 'shift-toward',
        maxWidth: 280,
        offset: [0, 16],
        placement: 'auto'
      })
    }
  }

  render () {
    return (
      <button
        type="button"
        className={classNames('border-coral border-2 rounded-1/2 icon icon-fill block items-center justify-center overflow-hidden p-0.5 ml-2 flex-shrink-0 cursor-pointer', this.props.className)}
        aria-hidden="true"
        ref={this.infoRef}
      >
        <span className={classNames(
          'block group-hover:bg-coral group-hover:fill-white group-focus:fill-white group-focus:bg-coral rounded-1/2 transition-colors duration-150 ease-in-out'
        )}
        >
          <Sprite name="infoBubble" />
        </span>
      </button>
    )
  }
}

InfoBubble.propTypes = {
  className: PropTypes.string,
  tooltip: PropTypes.string
}

export default InfoBubble
